import * as types from './mutation_types'

export default {
  [types.THUMBNAIL_DELETE_SET_DELETED] (state, deleted) {
    Object.assign(state, { deleted })
  },

  [types.THUMBNAIL_DELETE_SET_ERROR] (state, error) {
    Object.assign(state, { error })
  },

  [types.THUMBNAIL_DELETE_SET_LOADING] (state, isLoading) {
    Object.assign(state, { isLoading })
  },

  [types.THUMBNAIL_DELETE_RESET] (state) {
    Object.assign(state, {
      deleted: null,
      error: '',
      isLoading: false
    })
  }
}
